import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PromemoriaService } from 'src/app/core/promemoria.service';
import { Promemoria } from 'src/app/shared/models/promemoria.model';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-promemoria-dettaglio',
  templateUrl: './promemoria-dettaglio.component.html',
  styleUrl: './promemoria-dettaglio.component.scss'
})
export class PromemoriaDettaglioComponent {
  @Input({ required: true }) selectedPromemoria!: Promemoria | null;

  @Output() promemoriaAggiornato = new EventEmitter<void>();

  modaleVisibile: boolean = false;

  constructor(
    private readonly promemoriaService: PromemoriaService,
    private readonly messageService: MessageService
  ) {}

  openEditModal(): void {
    this.modaleVisibile = true;
  }

  eliminaPromemoria(): void {
    if (!this.selectedPromemoria) return;

    this.promemoriaService.deletePromemoria(this.selectedPromemoria.promemoriaId).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Promemoria eliminato correttamente'
        });
        this.promemoriaAggiornato.emit();
      },
      error: (err) => console.error(err)
    });
  }

  onPromemoriaModificato(): void {
    this.modaleVisibile = false;
    this.promemoriaAggiornato.emit();
  }
}